import React from 'react';
import { Link } from 'react-router-dom';

// "Our Story" cards (verbatim from the original site's landing page).
const STORY_CARDS = [
  {
    icon: '🌱',
    title: 'Why We Exist',
    body: "We started with a simple belief: beautiful, quality products shouldn't come at the cost of our planet. There had to be a better way to create things people love while respecting the earth.",
  },
  {
    icon: '🌍',
    title: "The Problem We're Solving",
    body: "Mass production has disconnected us from the origin of our products we use. We're changing that by creating products in small batches, where every component is natural, intentional and sustainable.",
  },
  {
    icon: '🤝',
    title: 'Who Makes Our Products',
    body: 'Sustainably Sprouted is proud to be a woman-owned small business. We create thoughtfully made, eco-friendly products using traditional methods, while minimizing environmental impact and prioritizing customer satisfaction.',
  },
];

export default function About() {
  return (
    <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-6)' }}>
      <h1>Our Story</h1>

      <div className="ss-feature-grid" style={{ marginTop: 'var(--ss-space-5)' }}>
        {STORY_CARDS.map((c) => (
          <div key={c.title} className="ss-feature-card">
            <div className="ss-feature-card__icon" aria-hidden="true">{c.icon}</div>
            <h3>{c.title}</h3>
            <p>{c.body}</p>
          </div>
        ))}
      </div>

      <p style={{ marginTop: 'var(--ss-space-6)', display: 'flex', gap: 'var(--ss-space-3)', flexWrap: 'wrap' }}>
        <Link className="ss-btn ss-btn--primary" to="/products">Explore the shop</Link>
        <Link className="ss-btn ss-btn--ghost" to="/contact">Get in touch</Link>
      </p>
    </section>
  );
}
